import { createReducer } from 'typesafe-actions';
import produce from 'immer';

import * as Actions from '../actions/basisGroupAction';
import { GroupState, initGroup } from '../models/basisGroupModel';

export const groupReducer = createReducer<GroupState, Actions.GroupAction>(
  initGroup
)
  .handleAction(Actions.MY_LIST.success, (state, action) =>
    produce(state, draft => {
      const { data, count } = action.payload;
      draft.myList = data;
      draft.myListCount = count;
    })
  )
  .handleAction(Actions.JOIN_LIST.success, (state, action) =>
    produce(state, draft => {
      const { data, count } = action.payload;

      const agreeList = data.filter(res => {
        if (res.aprvlYn === 'Y') {
          return res;
        }
      });
      draft.joinList = agreeList;
      draft.joinListCount = agreeList.length;

      // draft.joinList = data;
      // draft.joinListCount = count;
    })
  )
  .handleAction(Actions.GROUP_MAIN_LIST.success, (state, action) =>
    produce(state, draft => {
      const { data, count } = action.payload;
      // const agreeList = data.filter(res => {
      //   if (res.aprvlYn === 'Y') {
      //     return res;
      //   }
      // });
      // draft.mainList = agreeList;
      // draft.mainListCount = agreeList.length;

      draft.mainList = data;
      draft.mainListCount = count;
    })
  )

  .handleAction(Actions.GROUP_MYLIST.success, (state, action) =>
    produce(state, draft => {
      const { data, count } = action.payload;

      draft.joinList = data;
      draft.joinListCount = count;

      // draft.joinList = data;
      // draft.joinListCount = count;
    })
  )
  .handleAction(Actions.GROUP_CREATEID.success, (state, action) =>
    produce(state, draft => {
      const result = action.payload;

      draft.newGroupId = result;
    })
  )
  .handleAction(Actions.GROUP_DETAIL.success, (state, action) =>
    produce(state, draft => {
      const data = action.payload;
      draft.groupDetail = data;
    })
  )
  .handleAction(Actions.GROUP_LIST.success, (state, action) =>
    produce(state, draft => {
      const { data, count } = action.payload;
      draft.groupList = data;
      draft.groupListCount = count;
    })
  )
  .handleAction(Actions.GROUP_JOINLIST.success, (state, action) =>
    produce(state, draft => {
      const { data, count } = action.payload;
      draft.joinList = data;
      draft.joinListCount = count;
    })
  )
  .handleAction(Actions.APPROVAL_LIST.success, (state, action) =>
    produce(state, draft => {
      const { data, count, total } = action.payload;

      draft.aprvList = data;
      draft.count = count;
      draft.total = total;
    })
  )
  .handleAction(Actions.USER_LIST.success, (state, action) =>
    produce(state, draft => {
      const { data, count, total } = action.payload;
      draft.userList = data;
      draft.count = count;
      draft.total = total;
    })
  )
  .handleAction(Actions.SELECT, (state, action) =>
    produce(state, draft => {
      const selectData = action.payload;
      draft.selectData = selectData;
    })
  )
  .handleAction(Actions.GROUP_APRV_SELECT, (state, action) =>
    produce(state, draft => {
      const selectData = action.payload;
      draft.aprvSelect = selectData;
    })
  )
  .handleAction(Actions.GROUP_USER_SELECT, (state, action) =>
    produce(state, draft => {
      const selectData = action.payload;
      draft.userSelect = selectData;
    })
  );
